import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PeppolApParticipantRegistrationHdrContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_ap_participant_registration_hdr.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Pagination } from '../../shared/pagination.model';

@Injectable({
  providedIn: 'root'
})
export class PeppolApParticipantRegistrationHdrService extends BaseApiTemplateService<PeppolApParticipantRegistrationHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/ppl/participant-registrations'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/ppl/participant-registrations'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/ppl/participant-registrations'
    this.httpClient = http;
  }

  getParticipantRegistrationHdr(crossTenantCode: string,visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/${crossTenantCode}/cross-tenant-login-ep`

    }
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      this.getHttpHeader(visa)
    );
  }

  getParticipantRegistrationHdrByCriteria(
    crossTenantCode: string,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/${crossTenantCode}/cross-tenant-login-ep`
    }
    const UrlByCriteria =
      customUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getParticipantRegistrationHdrByGuid(
    crossTenantCode: string,
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/${crossTenantCode}/cross-tenant-login-ep`
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      customUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  postParticipantRegistrationHdr(crossTenantCode: string,dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/with-dto/${crossTenantCode}/cross-tenant-login-ep`
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  putParticipantRegistrationHdr(crossTenantCode: string,dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/${crossTenantCode}/cross-tenant-login-ep`
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  updateParticipantRegistrationHdrPostingStatus(crossTenantCode: string, dtoObject: any, ppl_registration_guid: string, posting_status: string, apiVisa: ApiVisa) {
    let customUrl;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/${crossTenantCode}/update-posting-status/cross-tenant-login-ep?ppl_registration_guid=${ppl_registration_guid}&posting_status=${posting_status}`

    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }

  uploadKyc(crossTenantCode: string, pplRegistrationGuid: string, file: File, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file);
    }
    let url = this.apiUrl + `/kyc/upload-pdf/${crossTenantCode}/cross-tenant-login-ep/${pplRegistrationGuid}`
    return this.httpClient.put(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }

  putWithDtoParticipantRegistrationHdr(crossTenantCode: string,dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/with-dto/${crossTenantCode}/cross-tenant-login-ep`
    }
    return this.httpClient.put<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getParticipantRegistrationKycFile(
    crossTenantCode: string,
    pplRegistrationGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/app-file-item-container/${crossTenantCode}/cross-tenant-login-ep/${pplRegistrationGuid}`
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      customUrl,
      this.getHttpHeader(visa)
    );
  }

}
